const ProductSidebar = ({ product, currentStep }) => {
  return (
    <div className="product-sidebar">
      <img src={product.img || "/placeholder.svg"} alt={product.name} className="product-sidebar-image" />
      <h2 className="product-sidebar-name">{product.name || "Product Name"}</h2>

      <div className="product-description">
        <p>
          {product.description ||
            "Premium quality cement for all your construction needs. Trusted by professionals across the country."}
        </p>
      </div>

      <div className="step-info">
        {currentStep === 1 && <p className="step-hint">Fill in the product details to continue</p>}
        {currentStep === 2 && <p className="step-hint">Request and negotiate rates</p>}
        {currentStep === 3 && <p className="step-hint">Upload your documents (optional)</p>}
        {currentStep === 4 && <p className="step-hint">Complete payment and place order</p>}
      </div>
    </div>
  )
}

export default ProductSidebar
